import {
    AsyncPipe,
    NgTemplateOutlet,
} from "@angular/common";
import {
    afterNextRender,
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    ElementRef,
    OnInit,
    ViewChild,
} from "@angular/core";
import { IconsDirective } from "@Front-end/seed/modules/icons";
import { SwiperContainer } from "swiper/element";
import { register } from "swiper/element/bundle";
import { SwiperOptions } from "swiper/types";
import { paymentsSliderConfig } from "./constants/payments-slider.constants";

@Component({
    selector: "ls-payments-slider",
    imports: [
        IconsDirective,
        AsyncPipe,
        NgTemplateOutlet,
    ],
    templateUrl: "./payments-slider.component.html",
    styleUrl: "./payments-slider.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    host: {
        class: "payments-slider",
    },
  })
export class PaymentsSliderComponent implements OnInit {
    constructor(
        private cdr: ChangeDetectorRef,
    ) {
        afterNextRender((): void => {
            this.swiperParams = {
                ...paymentsSliderConfig,
                on: {
                    progress: (swiper): void => {
                        this.swiperIsStart = swiper.isBeginning;
                        this.swiperIsEnd = swiper.isEnd;
                        this.cdr.detectChanges();
                    },
                },
            };

            if (this.swiperContainerRef) {
                Object.assign(this.swiperContainerRef.nativeElement, this.swiperParams);
                this.swiperContainerRef.nativeElement.initialize();
            }
        });
    }

    @ViewChild("swiperContainer")
    public swiperContainerRef!: ElementRef<SwiperContainer>;

    public swiperParams: SwiperOptions = { ...paymentsSliderConfig };
    public swiperIsStart = true;
    public swiperIsEnd = false;

    public ngOnInit(): void {
        register();
    }
}
